import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { ApiService } from "../shared/services/api.service";
import { catchError, map, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root"
})
export class PasswordTokenGuardComplaint implements CanActivate {
  constructor(private translate: TranslateService, private apiService: ApiService, private router: Router,  private toastr: ToastrService) { }

  /**
    * This security guard verifies the password reset token for a complaint in the URL. If valid, it allows the negotiation for the reset.
    * This security guard checks the URL for a `tokenPasswordComplaint` parameter and verifies it with the backend API.
   */
  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {    
    // Check if tokens already exist in localStorage (for page reloads)
    const urlParams = new URLSearchParams(window.location.search);
    var tokenPasswordComplaint = urlParams.get('tokenPasswordComplaint');

    if (!tokenPasswordComplaint) {
      // Token already exists, allow access
         tokenPasswordComplaint = localStorage.getItem('token_password_complaint');
    }

    if (tokenPasswordComplaint) {
      return this.apiService.verifyPasswordTokenComplaint(tokenPasswordComplaint).pipe(
        // Handle the response from the API service
        tap(response => {
          localStorage.setItem('token_password_complaint', response.accessToken);
        }),
        // If the token is valid, allow the route activation
        map(() => true),
        // If an error occurs, deny the route activation
        catchError((err) => {
          if(err.error.code === 401){
              this.toastr.error(
                  this.translate.instant('texto_954'),
                  this.translate.instant('texto_892'),
                  {
                    closeButton: true,
                    tapToDismiss: false
                  }
                );
          } else {
            this.toastr.error(
              this.translate.instant('texto_890'),
              this.translate.instant('texto_892'),
                {
                    closeButton: true,
                    tapToDismiss: false
                }
            );
          }
          this.router.navigate(["ver-denuncia/consultar-denuncia"]);
          localStorage.removeItem('token_password_complaint');
          return of(false);
        })
      );
    } else {
        this.toastr.error(
          this.translate.instant('texto_890'),
          this.translate.instant('texto_892'),
            {
                closeButton: true,
                tapToDismiss: false
            }
          );
        localStorage.removeItem('token_password_complaint');
        this.router.navigate(["ver-denuncia/consultar-denuncia"]);
        return false;
    }
  }
}
